import {SIDEBAR_DETAILS} from './SidebarType'


const initialState={
    UserName:10,
    Password:'',
    Role:'',
    Id:''
}

const sidebarReducer=(state=initialState,action)=>
{   
    switch(action.type)
    {
        case SIDEBAR_DETAILS: return{
            ...state,
            UserName:state.UserName,
            Password:state.Password,
            Role:state.Role,
            Id:state.Id
        }
        default: return state
    }
}

export default sidebarReducer;